<template>

  <t-page>

    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-input v-model="form.executorId" hidden/>

      <t-form-card title="Dados Básicos" icon-info-square>

        <t-input label="Responsável vinculado a um usuário da plataforma?"
                 help="Deixe como Não somente se desejar cadastrar um executor que não possua acesso, entretando você poderá inserir Responsáveis de forma rápida através do cadastro de usuários, onde é possível inclusive habilitar acesso somente via código."
                 v-model="yesOrNotLinkUser" :options="yesOrNotOptions"
                 radio/>

        <div v-show="onYesLinkUser">

          <t-input v-model="form.userId" :options="usersOptions" :add-error="error.userId"
                   label="Usuário da plataforma"  :required="onYesLinkUser" select/>

        </div>

        <div v-show="!onYesLinkUser">

          <t-input v-model="form.title" label="Denominação" :required="!onYesLinkUser"/>

        </div>


      </t-form-card>

      <t-form-card title="Avisos" icon-chat-right-text>

        <h6>Enviar avisos de apontamentos por:</h6>


        <b-row>

<!--          <b-col cols="6" style="max-width: 300px">

            <t-input v-model="form.warningSendByWhatsApp" checked label="WhatsApp" />
            <t-input v-model="form.warningWhatsApp" class-icon-group="icon-whatsapp-colored" v-show="form.warningSendByWhatsApp" tel :required="form.warningSendByWhatsApp" label="WhatsApp para envio">
              <template #input-icon>
                <b-icon-whatsapp />
              </template>
            </t-input>

          </b-col>-->


          <b-col cols="12">

            <t-input v-model="form.warningSendByEmail" checked label="E-mail" />
            <t-input v-model="form.warningEmail" class-icon-group="icon-mail-colored" v-show="form.warningSendByEmail" email-multiple :required="form.warningSendByEmail" label="E-mail para envio">
              <template #input-icon>
                <b-icon-envelope />
              </template>
            </t-input>

          </b-col>




        </b-row>



      </t-form-card>

      <!--
      <t-form-card title="Sistemaes atuantes" icon-box>

        <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.enableAllSectors" switch>
          Habilitar todos os setores para este executor?
          <t-help
              title="Você poderá especificar quais os setores desejados, basta desmarcar esta opção e especificar quais os setores abaixo."/>
        </b-form-checkbox>

        <t-table
            v-if="!form.enableAllSectors"
            enable-checked
            v-model="sectorsIds"
            :items="sectorsList"
            :fields="viewFieldsPageSector"
            title-items="setor"
            link-primary-column="name"
            table-bordered
            disable-actions-column
            primary-key-column="sectorId">

          <template #first-column="{item}">
            {{ item.name }}
          </template>

        </t-table>

      </t-form-card>
      -->

      <t-form-card title="Dados Adicionais" icon-folder>

        <e-person :person="form.person" not-required :command="command" :error="error_person"
                  @getApi="getEmbedCNPJApi"
                  :status="status"/>

        <e-address :address="form.address" not-required :command="command" :status="status"
                   @getApi="getEmbedAddressApi"/>


        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status text="Responsável" class="ml-1" v-model="form.status"/>

      </t-form-card>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import userService from "@/services/modules/setting/User.service";
import ePerson from "@/views/embed/general/e-person";
import eAddress from "@/views/embed/general/e-address";
import SectorService from "@/services/modules/agent/Sector.service";
import ui from "@/assets/scripts/ui";
import pageViewService from "@/services/modules/setting/PageView.service";


export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'InspectorForm',
  components: {ePerson, eAddress},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "executorId",
      form: {
        executorId: 0,
        executorNumber: 0,
        userId: 0,
        title: "",
        enableAllSectors:true,
        warningSendByEmail:true,
        warningSendByWhatsApp:false,
        warningEmail:"",
        warningWhatsApp: "",
        sectors: [],
        person: {
          /*Embed Person version: 1.0*/
          typePerson: 2,
          name: "",
          shortName: "",
          companyName: "",
          federalTaxpayer: "",
          otherPersonalDocument: "",
          provinceTaxpayer: "",
          provinceTaxpayerExempted: true,
          cityTaxpayer: "",
          /*-------------------------*/
        },
        address: {
          /*Embed Address version: 1.0*/
          country: "BR",
          zipcode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          provinceAbbreviation: "",
          cityId: 0
          /*-------------------------*/
        },
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        userId: "",
        name: "",
      },
      /*Embed Person Errors version: 1.0*/
      error_person: {
        name: "",
        federalTaxpayer: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      sectorsIds: [],
      sectorsList: [],
      viewFieldsPageSector: [],
      yesOrNotLinkUser: "N", //Valor padrão não possui vinculo com usuário
      usersOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    async onSubmit() {

      this.form.sectors = this.convertArrayIdsToObject(this.sectorsIds, "sectorId")

      if (!this.form.enableAllSectors && this.form.sectors.length === 0) {
        ui.msgError(this, "Selecione pelo menos 1 setor no qual este executor atua.")
      } else {
        await this.setSendingDefault()
      }

    },
    mountedPrepare() {


    },
    async mountedContinued() {

      await pageViewService.getViewFieldsByPage(193, true, [""]).then((response) => {
        this.viewFieldsPageSector = response
      }).catch(error => this.responseError(error))

      await userService.selectList("").then((list) => {
        this.usersOptions = list
      }).catch(error => this.responseError(error))

      await SectorService.getAllSectors().then((list) => {
        this.sectorsList = list
        this.sectorsIds = this.convertObjectToArrayIds(this.form.sectors, "sectorId")
      }).catch(error => this.responseError(error))


      this.pageFormIsLoaded = true

      if (this.form.userId > 0) {
        this.yesOrNotLinkUser = "Y"
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  computed: {
    onYesLinkUser() {
      return this.yesOrNotLinkUser === 'Y'
    }
  }

}
</script>
